export default function MaintenanceMode() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center p-8 max-w-md">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          System Maintenance
        </h1>
        <p className="text-gray-600 mb-4">
          We're currently performing system maintenance to improve your
          experience. Please check back soon.
        </p>
        <div className="animate-pulse flex justify-center">
          <div className="h-2 w-20 bg-blue-500 rounded"></div>
        </div>
      </div>
    </div>
  );
}
